import { Button, Dialog } from '@cinesend/ui-kit'

const AppDialog = ({
  title,
  onClose,
  confirmText,
  onConfirm,
  confirmDisabled = false,
  confirmVariant = 'primary',
  size,
  children,
}) => (
  <Dialog
    open
    title={title}
    size={size}
    onOpenChange={(open) => !open && onClose()}
    hasActions={!!onConfirm}
    actionSecondary={
      <Button variant='secondary' onClick={onClose}>
        Cancel
      </Button>
    }
    actionPrimary={
      <Button variant={confirmVariant} disabled={confirmDisabled} onClick={onConfirm}>
        {confirmText}
      </Button>
    }
  >
    <div className='flex flex-col gap-4 px-6 pb-6 pt-4'>{children}</div>
  </Dialog>
)

export default AppDialog
